import React from 'react';
import parse from 'html-react-parser'
import LanguageSelector from './LanguageSelector'
import i18n from './Lang'

function Linkedn(){
    return <div className="linkedin-image linkedin display-flex justify-center">
        <svg xmlns="http://www.w3.org/2000/svg" className="loader__linkedin-logo" width="140" height="48" viewBox="0 0 190 48">
          <g>
            <g>
              <path d="M58,27.22V41H51V28.88c0-3.7-2.07-5.24-4-5.24a5,5,0,0,0-5.14,4.85,4.34,4.34,0,0,0,0,.51V41H35V18h6.6v3.25h.09c.69-1.41,3.64-3.75,7.66-3.75S58,20.22,58,27.22ZM24,41h7V18H24ZM27.5,6.45a4.05,4.05,0,1,0,4.1,4.05,4,4,0,0,0-4-4ZM190,3.5v41a3.5,3.5,0,0,1-3.5,3.5h-41a3.5,3.5,0,0,1-3.5-3.5V3.5A3.5,3.5,0,0,1,145.5,0h41A3.5,3.5,0,0,1,190,3.5ZM156,18h-7V41h7Zm.6-7.5a4.1,4.1,0,1,0-4.15,4.05h.05a4,4,0,0,0,4.1-3.9ZM183,27.22c0-7-4.63-9.72-8.65-9.72s-7,2.34-7.66,3.75h-.09V18H160V41h7V29c0-3.69,2.51-5.33,4.95-5.33,2,0,4.05,1.54,4.05,5.24V41h7ZM8,7H0V41H21V34H8ZM108,29.77v2H91a1.33,1.33,0,0,0,.11.43c.58,1.93,2.67,3.56,5.75,3.56A6.3,6.3,0,0,0,102,33.52l5.1,3.18a12.72,12.72,0,0,1-10.45,4.8C89.94,41.5,84,37.42,84,29.59S90,17.5,96.44,17.5,108,21.81,108,29.77ZM101,27c0-2.4-1.56-4.38-4.75-4.38-3,0-5.09,2-5.25,4.38ZM85.26,18H76.68l-7.54,9.37H69V7H62V41h7V30h.14l7.72,11h8.77L76.2,28.43ZM128,7h7V41h-6.6V38h-.09c-.88,1.52-3.24,3.49-7.4,3.49-5,0-10.91-3.63-10.91-12,0-7.53,5.1-11.95,10.82-11.95a9.55,9.55,0,0,1,7.09,3H128Zm.3,22.49a5.74,5.74,0,0,0-5.59-5.89h-.15A5.54,5.54,0,0,0,116.89,29c0,.15,0,.29,0,.44a5.61,5.61,0,0,0,5.26,5.94h.4A5.83,5.83,0,0,0,128.3,29.49Z" fill="currentColor"></path>
            </g>
          </g>
        </svg>
      </div>
}

function Header(props) {

    const { data, keys } = props; // Access the data and i18n props
    return (
            <div className='header'>
                <img className='avatar hover-zoom' src={require('./juju.jpeg')} height="130" />
                <div className='infos'>
                    <div className='name'><b>{ data.User.name }</b></div>
                    <div className='job'><b>{ data.User.job }</b></div>
                    <div className='more'>{ data.User.more }</div>
                    <div className='mail'>{ parse(data.User.mail) }</div>
                    <div className='phone'>{ parse(data.User.phone) }</div>
                    <div>{keys.location}: { data.User.loc }</div>
                    <div><a className='site' href={ data.User.site_url }>{ data.User.site_url }</a></div>
                </div>

                <div className='socials' >
                  <div className='linkedin' >
                    <a href={ data.User.linkedin_url } target='_blank'><Linkedn /></a>
                  </div>
                  <div className='pdf' >
                    <a href={ data.User.pdf_path } class="no-a-effect" target='_blank'>PDF</a>
                  </div>
                </div>
                <div className='language-selector'>
                    <LanguageSelector i18n={i18n} />
                </div>
            </div>
        );
} 
export default Header;